/**
 * Botão flutuante WhatsApp + diálogo opcional.
 * Antes: theme.whatsappPopup em theme.js.
 */
(function () {
  "use strict";

  function initWhatsappPopup(section) {
    if (!section) return;

    var chatButton = section.querySelector("#essence-wpp-whatsapp-chat-btn");
    var dialog = section.querySelector("#essence-wpp-whatsapp-chat-dialog");
    var userForm = section.querySelector("#essence-wpp-whatsapp-chat-dialog-user-form");
    var userInput = section.querySelector("#essence-wpp-whatsapp-chat-dialog-user-input");
    var whatsappNumber = (section.dataset.whatsappNumber || "").split("-").join("");
    var hasDialog = section.dataset.hasDialog === "true";

    function closeDialog() {
      if (!dialog) return;

      dialog.removeAttribute("open");
      section.setAttribute("data-dialog-open", "false");
      if (chatButton) chatButton.focus();
    }

    function trapFocus() {
      if (!dialog) return;
      var focusableElements = dialog.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements.length === 0) return;

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      function handleTab(event) {
        if (event.key !== "Tab") return;

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }

      dialog.addEventListener("keydown", handleTab);
    }

    function openDialog() {
      if (!dialog) return;

      dialog.setAttribute("open", "");
      section.setAttribute("data-dialog-open", "true");

      setTimeout(function () {
        if (userInput) userInput.focus();
      }, 300);

      setTimeout(function () {
        var typing = section.querySelector("#essence-wpp-whatsapp-chat-dialog-msg-typing");
        var text = section.querySelector("#essence-wpp-whatsapp-chat-dialog-msg-text");
        if (typing) typing.style.display = "none";
        if (text) text.style.display = "block";
      }, 2000);

      trapFocus();
    }

    function toggleDialog() {
      if (!dialog) return;

      if (dialog.hasAttribute("open")) {
        closeDialog();
        return;
      }

      openDialog();
    }

    function openWhatsApp() {
      if (!chatButton) return;

      chatButton.classList.add("loading");
      setTimeout(function () {
        window.open("https://wa.me/" + whatsappNumber, "_blank");
        chatButton.classList.remove("loading");
      }, 1000);
    }

    function bindChatButton() {
      if (!chatButton) return;

      chatButton.addEventListener("click", function () {
        if (hasDialog) {
          toggleDialog();
        } else {
          openWhatsApp();
        }
      });
    }

    function bindCloseButton() {
      var closeButton = section.querySelector("#essence-wpp-whatsapp-chat-dialog-close");
      if (!closeButton) return;

      closeButton.addEventListener("click", function () {
        closeDialog();
      });
      section.addEventListener("keyup", function (event) {
        if (event.code === "Escape") closeDialog();
      });
    }

    function handleKeyboard() {
      if (!dialog || !userInput) return;

      userInput.addEventListener("focus", function () {
        dialog.setAttribute("data-keyboard-open", "");
      });
      userInput.addEventListener("blur", function () {
        dialog.removeAttribute("data-keyboard-open");
      });
    }

    function handleFormSubmit() {
      if (!userForm) return;

      userForm.addEventListener("submit", function (event) {
        event.preventDefault();
        var submitButton = section.querySelector("#essence-wpp-whatsapp-chat-dialog-btn");
        if (submitButton) submitButton.classList.add("loading");

        setTimeout(function () {
          var text =
            userInput && userInput.value ? "?text=" + encodeURIComponent(userInput.value) : "";
          window.open("https://wa.me/" + whatsappNumber + text, "_blank");
          if (submitButton) submitButton.classList.remove("loading");
        }, 1000);
      });
    }

    bindChatButton();
    bindCloseButton();
    handleKeyboard();
    handleFormSubmit();
  }

  function boot(root) {
    (root || document).querySelectorAll(".whatsapp-popup").forEach(initWhatsappPopup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    var el = event.target.querySelector(".whatsapp-popup");
    if (el) initWhatsappPopup(el);
  });
})();
